// extracted by mini-css-extract-plugin
export default {"info":"wG4Y166pOgqF26BBT2Ph","title":"I9hGPIHCsVXrbn5CYFmX","organization":"pjpLeXQ3Gi0bTUCT4j2K"};